import { useSelector } from "react-redux";
import ReadMoreReadLess from "../generic-read-more/ReadMoreReadLess";
import { getConfigurationByIdField } from "../../app/helpers/getConfigurationByIdField";

const VISION_IMPORT_NAME_LIMIT_FIELD = "vision.import.name.readmore_limit";
const DEFAULT_NAME_LIMIT = 200;

const resolveNameLimit = (configurations) => {
    const row = getConfigurationByIdField(VISION_IMPORT_NAME_LIMIT_FIELD, configurations || []);
    const parsed = Number(String(row?.value || "").trim());
    if (!Number.isFinite(parsed) || parsed < 1) {
        return DEFAULT_NAME_LIMIT;
    }
    return Math.floor(parsed);
};

function TableDataVisionBootstrap({ data, savedColumnLabel = 'Guardado' }) {
    const configurations = useSelector((state) => state.configuration?.configurations || []);
    const nameLimit = resolveNameLimit(configurations);

    const columns = [
        { header: 'Nro', key: 'rowNumber', width: 23, visible: true },
        { header: 'Mensaje', key: 'stepsErrors', width: 23, visible: true },
        { header: 'Valido', key: 'isValid', width: 23, visible: true },
        { header: savedColumnLabel, key: 'isSaved', width: 23, visible: true },
        { header: 'Id', key: 'registerId', width: 23, visible: true },
        { header: 'Codigo', key: 'code', width: 11, visible: true },
        { header: 'Nombre', key: 'name', width: 80, visible: true },

    ];

    return (
        <div>
            <div className="text-start">
                <strong>Data de Tecnología importada:</strong>
            </div>
            <div className="table-responsive">
                <table className="table table-bordered">
                    <thead>
                        <tr className=''>
                            {data && data.length > 0 && columns && columns.length > 0 && (
                                columns.map((item) => {
                                    return (
                                        <th className='' key={item.key}>{item.header}</th>
                                    )
                                })
                            )}
                        </tr>
                    </thead>
                    <tbody>

                        {data && data.length > 0 && (
                            data.map((item, index) => {
                                const visionName = item?.values?.vision == null ? "" : String(item.values.vision);
                                return (
                                    <tr key={index} className=''>
                                        <td className="list-table-cell-50"> {item.rowNumber} </td>
                                        <td className="list-table-cell-400"> {item.stepsErrors} </td>
                                        <td className="list-table-cell-50"> {item.isValid ? "Si" : "No"} </td>
                                        <td className="list-table-cell-50"> {item.isSaved ? "Si" : "No"} </td>
                                        <td className="list-table-cell-100"> {item.registerId && item.registerId !== -1 ? item.registerId : "—"} </td>
                                        <td className="list-table-cell-150"> {item.values.code_vision} </td>
                                        <td className="list-table-cell-400">
                                            <ReadMoreReadLess
                                                className="read-more-less"
                                                buttonClassName="btn-read-more-less"
                                                expandLabel="Leer más"
                                                collapseLabel="Leer menos"
                                                limit={nameLimit}
                                            >
                                                {visionName}
                                            </ReadMoreReadLess>
                                        </td>
                                    </tr>
                                )
                            })
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    )
}

export default TableDataVisionBootstrap
